define(function (require) {
    var avalon = require('avalon'),
        ajax = require('ajax'),
        dialog = require('dialog'),
        tool = require('toolLoaderPC'),
        WebUploader = require('webuploader');

    var hiddenValues, globleValues, refundKit;

    var vmodel = avalon.define({
        $id: 'applyRefundController',

        max_refund_fee: null,
        refund_fee: null,
        refund_reason: '',
        refund_remark: null,
        images: [],
        timeout: false,

        type: '1',
        // 类型不能点击了
        // typeClick: function(type) {
        //     vmodel.type = type;
        // },

        backClick: function () {
            ajax.pjax(hiddenValues.referrer);
        },

        submitClick: function () {
            if (
                !vmodel.refund_fee ||
                vmodel.refund_fee == '' ||
                parseFloat(vmodel.refund_fee) <= 0
            ) {
                dialog.alert('请填写正确的申请金额');
                return;
            }
            if (
                parseFloat(vmodel.refund_fee) >
                parseFloat(vmodel.max_refund_fee)
            ) {
                dialog.alert('申请金额必须小于等于最大申请金额');
                return;
            }
            if (!vmodel.refund_reason || vmodel.refund_reason == '') {
                dialog.alert('请选择退款原因');
                return;
            }

            vmodel.refund_remark = vmodel.refund_remark || '';
            if (vmodel.refund_remark.length > 100) {
                dialog.alert('退货描述请小于100字符');
                return;
            }

            tool.singleWay(
                'mall-order-pay-refound-' + hiddenValues.og_id,
                function (key) {
                    refundKit = this;
                    ajax
                        .postWithFail('apply-refund.html', {
                            og_id: hiddenValues.og_id,
                            type: vmodel.type,
                            refund_fee: parseFloat(vmodel.refund_fee),
                            refund_reason: vmodel.refund_reason,
                            refund_remark: vmodel.refund_remark,
                            refund_img: JSON.stringify(vmodel.images)
                        })
                        .done(function (response) {
                            refundKit.resolve(key);

                            if (response.type === 'succ') {
                                ajax.pjax(
                                    'apply-success.html?refund_id=' +
                                    response.msg
                                );
                            }
                        })
                        .fail(function () {
                            refundKit.resolve(key);
                        });
                }
            );
        },

        deleteImagesClick: function (el) {
            vmodel.images.remove(el);
        }
    });

    vmodel.$watch('refund_fee', function (n) {
        if (n && n != '') {
            var v = translate(n);
            vmodel.refund_fee = v;
        }
    });

    // avalon.duplexHooks.float = {
    //     get: function(val, binding) {
    //         if(val != '') {
    //             var v = translate(val);
    //             binding.element.value = v;
    //             return v;
    //         }
    //     },
    //     set: function(val) {
    //         console.log(val)
    //         console.log(vmodel.refund_fee)
    //         return val;
    //     }
    // };

    function translate (val) {
        var old = val + '';

        var re = /^[0-9]+\.{0,1}[0-9]{0,2}$/; // 限制小数点后两位
        while (!re.test(old) && old !== '') {
            old = old.substr(0, old.length - 1);
        }

        return old;
    }

    return {
        init: function () {
            hiddenValues = tool.getHiddenValues('#js-local-hiddens');
            globleValues = tool.getHiddenValues('#js-hiddens');
            vmodel.max_refund_fee = hiddenValues.max_refund_fee;

            if (hiddenValues.timeout === '1') {
                vmodel.timeout = true;
            }
            if (hiddenValues.order_status == '2') {
                vmodel.type = '1';
            } else if (
                hiddenValues.order_status == '3' ||
                hiddenValues.order_status == '4'
            ) {
                vmodel.type = '2';
            }

            var fileMaxSize = 1024 * 1024 * 2;
            var uploader = WebUploader.create({
                auto: true,
                swf:
                    globleValues.frontUrl +
                    '/frontcommon_assets/swf/Uploader.swf',
                server: '../../pay/refund/images.html?mod=refund',
                pick: '#filePicker',
                accept: {
                    title: 'Images',
                    extensions: 'gif,jpg,jpeg,bmp,png',
                    mimeTypes: 'image/gif,image/jpg,image/jpeg,image/png'
                },
                fileVal: 'thefile',
                fileSingleSizeLimit: fileMaxSize,
                duplicate: true
            });
            uploader.on('uploadSuccess', function (file, response) {
                if (response.type === 'succ') {
                    vmodel.images.push(response.msg.fileurl);
                } else {
                    dialog.alert(response.msg);
                }
            });
            uploader.on('beforeFileQueued', function (file) {
                if (file.size > fileMaxSize) {
                    dialog.alert('文件大小超过2M限制');
                    return false;
                } else if (vmodel.images.length >= 5) {
                    dialog.alert('最多上传5张图片');
                    return false;
                }
            });
        },
        clear: function () { }
    };
});



// WEBPACK FOOTER //
// ./src/js_modules/applyRefundController.js